import $A from 'plugins/tfs/platformConfigs/app';
import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/signIn';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import React, { useState, useMemo, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import Error from 'theme/Error';

// pageContainer
import StaffSelection from '_pageContainers/staffSelection';

const getFullName = (firstName, lastName) => `${firstName.toLocaleLowerCase('tr')} ${lastName.toLocaleLowerCase('tr')}`;

const StaffSelectionGrid = (pageContext) => {
  const {
    props: { staffs: _staffs, error, currentStore, currentStaff },
    selectionHandler,
    staffLogin,
    selectedStaff,
  } = pageContext;

  const [query, setQuery] = useState('');

  let localRetailStaffs = JSON.parse(
    localStorage.getItem('localCurrentRetailStore')
  );

  let currentStoreInformation = JSON.parse(localStorage.getItem('usedStorage'));

  let localStaffs = JSON.parse(
    localStorage.getItem('localStaffs')
  );

  const staffs = useMemo(() => {
   let allStaffs = localStaffs || [];
    if(_staffs.length > 0 && typeof _staffs[0] !== 'string') {
      allStaffs = _staffs;
    }

    if(Array.isArray(allStaffs)) {
      allStaffs = allStaffs.sort((a, b)=>{
        const aFullName = getFullName(a.first_name, a.last_name);
        const bFullName = getFullName(b.first_name, b.last_name);
        return aFullName.localeCompare(bFullName, $A.LANGUAGE, { sensitivity: 'base' });
      });
  
      if(query.trim().length > 0) {
        const searchQuery = query.trim().toLowerCase();
  
        return allStaffs.filter((staff) => {
          const fullName = getFullName(staff.first_name, staff.last_name);
          const firstName = staff.first_name.toLowerCase();
          const lastName = staff.last_name.toLowerCase();
  
          return firstName.includes(searchQuery)
          || lastName.includes(searchQuery)
          || fullName.includes(searchQuery);
        });
      }
      return allStaffs;
    }
    return [];
  }, [query, _staffs, localRetailStaffs]);

  const handleInputChange = (event) => {
    setQuery(event.target.value);
  };

  const clearQuery = () => {
    setQuery('');
  };

  useEffect(() => {
    localStorage.setItem('localCurrentStaff', JSON.stringify(selectedStaff.id));
    localStorage.setItem(
      'localCurrentRetailStore',
      JSON.stringify(
        _staffs.length > 0
          ? _staffs
          : JSON.parse(localStorage.getItem('localCurrentRetailStore'))
      )
    );
  }, [_staffs, selectedStaff]);

  if (staffLogin === true) {
    return (
      <Redirect
        to={{
          pathname: $R.STAFF_LOGIN.path,
          state: { selectedStaff },
        }}
      />
    );
  }

  return (
    <div className='container-fluid headerMargin__onlyLogo'>
      <div className='row'>
        <div className='col-12 col-md-6'>
          <div className='row justify-content-md-center login_form-container'>
            <div className='col-12 col-md-8'>
              <div className='login_partial-container'>
                <h1>{$ST.SELECTED_STORE}</h1>
                <div className='addresses'>
                  <p className='address__title'>
                    {currentStore !== undefined &&
                    currentStore.name !== undefined
                      ? currentStore.name
                      : currentStoreInformation.name}
                  </p>
                  <p className='address__content'>
                    {`
                        ${
                          currentStore !== undefined &&
                          currentStore.address !== undefined
                            ? currentStore.address.line
                            : currentStoreInformation.address.line
                        }
                        ${
                          currentStore !== undefined &&
                          currentStore.address !== undefined
                            ? currentStore.address.township.name
                            : currentStoreInformation.address.township.name
                        }/
                        ${
                          currentStore !== undefined &&
                          currentStore.address !== undefined
                            ? currentStore.address.township.city.name
                            : currentStoreInformation.address.township.city.name
                        }`}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-8 login_partial-container bottom-border'>
              <p className='select-lighter text-center'>
                {staffs.length > 0 && staffs[0].id
                  ? $ST.SELECT_USER
                  : currentStoreInformation && $ST.SELECT_USER}
                <br />
                <form>
                  <input
                    className='store-filter-input'
                    placeholder={$ST.FIND_USER}
                    value={query}
                    onChange={handleInputChange}
                  />
                </form>
              </p>
              <Error data={error} field='staff' />
            </div>
          </div>
        </div>

        <div className='col-12 col-md-6 store-select-wrapper'>
          {staffs.length > 0 && staffs[0].id ? (
            <div className='row'>
              {staffs.map((staff) => {
                const disableItem = staff.id === currentStaff.id;
                return (
                  <div
                    onClick={
                      disableItem ? () => {} : () => selectionHandler(staff)
                    }
                    className='col-12 col-sm-6 col-md-6 col-xl-4 item_container'
                    key={staff.id}
                  >
                    <div
                      className={`user-item pointer ${
                        disableItem ? 'user-item__disable' : ''
                      }`}
                    >
                      <p className='user-item__title'>{`${staff.first_name} ${staff.last_name}`}</p>
                      <p className='user-item__content'>{staff.remote_id}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}
          {query.length > 0 && staffs.length === 0 && (
            <div className='not-found-wrapper'>
              <p>{$ST.USER_NOT_FOUND}</p>
              <button onClick={clearQuery}>{$ST.CLEAR_SEARCH}</button>
            </div>
          )}
          {staffs.length === 0 ||
            (!staffs[0].id && localRetailStaffs.length === 0 && (
              <div className='text-center'>{$ST.USER_NOT_FOUND}</div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default StaffSelection(StaffSelectionGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/staffSelection/index.js